import { render, staticRenderFns } from "./MAM_stockTools.vue?vue&type=template&id=21ac8afc&scoped=true&"
import script from "./MAM_stockTools.vue?vue&type=script&lang=js&"
export * from "./MAM_stockTools.vue?vue&type=script&lang=js&"
import style0 from "./MAM_stockTools.vue?vue&type=style&index=0&id=21ac8afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac8afc",
  null
  
)

export default component.exports